import React, { useEffect } from "react";
import Cart from "@system/config/cart";
import noImage from 'src/assets/images/noimage.png'
import System from 'src/helper/system';
import NavigateToProductDetail from 'src/component/custom/NavigateToProductDetail';
import DisplayLongDescriptionAndVariantMFRName from 'src/component/custom/DisplayLongDescriptionAndVariantMFRName';
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import { useBOMStore } from "src/hooks/bom";
import { useProductInventoryPriceStore } from 'src/hooks/productInventoryPrice';
import Constants from "src/helper/Constants";
import { useCartStore } from "src/hooks/cart";

const AddedToCartBomPopup = (props) => {
    const { data, SetStatus } = props
    const [{ bom_detail_by_bom_id, bom_detail_by_bom_id_type, bom_project_list }] = useBOMStore();
    const [{ }, { get_inventory_by_id }, { }] = useProductInventoryPriceStore();
    const [{}, { fetch_cart_data }, {}] = useCartStore();
    const { currencyType: { USD } } = Constants


    useEffect(() => {
        if (data?.cartData) {
            addtoCartEvent();
        }
        fetch_cart_data({ minicart: true })
    }, []);

    const onHide = (action = true) => {
        SetStatus(false)
    };

    const getSubTotal = () => {
        let subtotal = 0;
        if (data?.cartData.length > 0) {
            data?.cartData.map((v) => {
                subtotal = subtotal + v.subtotal
            })
            return System.getFormatNumber({ amount: Number(subtotal), maximumFractionDigits: 2, isDisplaySymbol: false, currency: USD })
        }
    }

    //By Ramya Kannan [Add to cart/BOM - Adobe script ]
    function addtoCartEvent() {
        let prodDetails = [...data.cartData];
        let bomDetails = { ...bom_detail_by_bom_id };
        bomDetails.exactMatchCount = bom_detail_by_bom_id_type?.Exact?.count;
        bomDetails.nomatchCount = bom_detail_by_bom_id_type?.NoMatch?.count;
        bomDetails.multipleMatchCount = bom_detail_by_bom_id_type?.Multiple?.count;
        if (bom_project_list) {
            bomDetails.projectName =
                bom_project_list[bomDetails?.projectId]?.projectName;
        }
        prodDetails.forEach((data,key)=>{
          let copyObj = {...data};
          copyObj.qas = get_inventory_by_id(copyObj.ItemNumber || copyObj.itemNumber)?.inventoryQty || 0;
        //   copyObj.priceSource = bomCartDetails[key]?.priceSource;
        //   copyObj.unitPrice = bomCartDetails[key]?.unitPrice;
        //   copyObj.subtotal = bomCartDetails[key]?.subtotal;

            prodDetails[key] = copyObj;
        })
        let cartDetails = {
            additionSource: "BOM",
            cartType: "checkout",
          cartId:prodDetails[0]?.cartId
        };
        localStorage.setItem("adobeEventType", "addToCartEvent");
        if (Object.keys(prodDetails).length && Object.keys(cartDetails).length) {
            HelperAdobeEvent.trackingAdobeEvent({
                prodDetails,
                cartDetails,
                bomDetails,
            });
        }
        }
    return (
        <>
            <div>
                {(data?.cartData && data?.cartData.length > 0) &&
                    <div className="avnet-modal modal-680">
                        <div className="avnet-modal-inner">
                            {/* Modal Header */}
                            <button type="button" className="close py-3" data-dismiss="modal"
                                onClick={() => { onHide() }}
                            >×</button>
                            <div className="modal-header justify-content-center mt-0">
                                <h3 className="pcn-modal-heading pl-5">({data?.cartData.length}) Item(s) Added to Your Cart</h3>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="clearfix" />
                                <div className="add-to-cart-list ordercartlist">
                                    {data?.cartData.map((v, i) => (
                                        <div key={i} className="add-to-cart-item">
                                            <div className="bs5 row m-0">
                                                <div className="col-auto p-0">
                                                    <div className="add-to-cart-item-img">
                                                        <img className="img-fluid" src={v.assetURL && v.assetURL.trim() !== '' ? v.assetURL : noImage} />
                                                    </div>
                                                </div>
                                                <div className="col-auto p-0">
                                                    <div className="add-to-cart-item-info">
                                                        <NavigateToProductDetail data={{ ManufacturerName: v.manufacturerName, ERPMFRPartNumber: v.erpMfrPartNumber, ItemNumber: v.itemNumber, ERPPartNumber: v.ERPPartNumber }}>
                                                            {v.erpMfrPartNumber}
                                                        </NavigateToProductDetail>
                                                        <DisplayLongDescriptionAndVariantMFRName
                                                            currentProduct={{ ManufacturerName: v?.manufacturerName, ShortDescription: v?.ShortDescription }} />
                                                    </div>
                                                </div>
                                                <div className="col-12 col-sm-auto mt-3 mt-sm-0 ms-auto p-0">
                                                    <div className="add-to-cart-price">
                                                        <div className="add-to-cart-price-item">
                                                            <span>Unit Price:</span>
                                                            <b>{System.getFormatNumber({ amount: Number(v.unitPrice), currency: USD })} </b>
                                                        </div>
                                                        <div className="add-to-cart-price-item">
                                                            <span>Quantity:</span>
                                                            <b>{v.quantity}</b>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}

                                </div>
                                <div className="text-end mt-2 font-12 cart-subtotal">
                                    <span> Item Subtotal ({USD}): &nbsp;
                                        <b>
                                            {getSubTotal()}
                                        </b>
                                    </span>
                                </div>
                            </div>
                            {/* Modal footer */}
                            <div className="modal-footer text-center">
                                <div className="modal-footer-actions">
                                    <button onClick={() => { onHide() }}
                                        type="button" className="bs5 btn btn-secondary btn-sm"
                                        data-dismiss="modal">
                                        CONTINUE SHOPPING
                                    </button>
                                    <button type="button" className="bs5 btn btn-primary btn-sm w145"
                                        onClick={() => { window.location.href = Cart.getCartPageRouteURL() }}
                                        data-dismiss="modal">
                                        VIEW CART
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </>
    );
}

export default AddedToCartBomPopup;